import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '../../../atomic/Buttons/Button';
import Icon from '@material-ui/core/Icon';

//Components
import Level from './Level';

const CardStyled = styled(Card)`
  display: flex;
  min-height: 90px;
`
const CardMediaStyled = styled(CardMedia)`
  min-width: 90px;
  min-height: 90px;
`
const Details = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  flex: 1 1 auto;
  flex-direction: row;
  max-width: 100%;
`
const Overlay = styled.div`
  display: flex;
  position: absolute;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`
const SideContent = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
  background: linear-gradient(90deg, rgba(2,0,36,0) 0%, rgba(255,255,255,1) 22%, rgba(255,255,255,1) 100%);
`
const LevelContainer = styled.div`
  display: flex;
  align-items: flex-end;
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0;
  align-items: center;
`
const LeftButtonContainer = styled(ButtonContainer)`
  padding: 0 8px;
`

const DefaultButton = styled(Button)`
  background: black;
  color: white;
  max-height: 50px;
  min-height: 50px;
  max-width: 50px;
  min-width: 50px;
  border-radius: 10px;
  `
  const RemoveButton = styled(Button)`
  background: red;
  color: white;
  max-height: 45px;
  min-height: 45px;
  max-width: 45px;
  min-width: 45px;
  border-radius: 10px;
`
const IconStyled = styled(Icon)`
  font-size: 24px;
`

const ListCard = ({
  image,
  level,
  levels,
  children,
  onClick,
  onCardClick,
  onDelete,
  cardButtonIcon,
  cardButtonLeft,
  classes,
  theme,
  ...other
}) => {

  const clicked = event => {
    event.stopPropagation();
    onClick();
  }

  const deleted = event => {
    event.stopPropagation();
    onDelete();
  }

  return (
    <CardStyled onClick={onCardClick} {...other}>
      {
        image &&
        <CardMediaStyled
          image={image}
        />
      }
      {
        cardButtonLeft && onClick && (
          <LeftButtonContainer>
            <DefaultButton variant="contained" onClick={clicked}>
              <IconStyled>{cardButtonIcon}</IconStyled>
            </DefaultButton>
          </LeftButtonContainer>
        )
      }
      <Details>
        {children}
        <Overlay>
          <SideContent>
            { level && (
              <LevelContainer>
                <Level level={level} levels={levels} />
              </LevelContainer>
            )}
            <ButtonContainer>
            { onDelete && (
              <RemoveButton variant="contained" onClick={deleted}>
                <IconStyled>remove</IconStyled>
              </RemoveButton>
            )}
            { !cardButtonLeft && onClick && (
              <DefaultButton variant="contained" onClick={clicked}>
                <IconStyled>{cardButtonIcon}</IconStyled>
              </DefaultButton>
            )}
            </ButtonContainer>
          </SideContent>
        </Overlay>
      </Details>
    </CardStyled>
  )
}

ListCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  image: PropTypes.string,
  level: PropTypes.number,
  cardButtonIcon: PropTypes.string,
  onClick: PropTypes.func,
  onCardClick: PropTypes.func,
  onDelete: PropTypes.func,
};

ListCard.defaultProps = {
  onCardClick: (() => null),
  cardButtonIcon: 'arrow_forward',
  cardButtonLeft: false
  // header: 'hello',
  // subtext: '#warmup #dig #stuff',
  // muscleGroup: ['arms','legs','chest'],
};

export default withStyles(null, { withTheme: true })(ListCard);
